import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Envs } from '../../../envs.js';
import FakePlayer from './fake-player.js';

let PlayerComponent;
if (Envs.NODE_ENV === 'test') {
  // console.log to add fake-player to build bundle
  console.log(FakePlayer);
  PlayerComponent = require('./fake-player').default;
} else {
  PlayerComponent = require('@mux/mux-player-react').default;
}
// Fake mux-player to not break jest of chatpay-firebase, because not find mux-player-react in dependencies tree
// TODO: when migrate chatpay-firebase to nx, remove this fake player and mock only jest
const MuxPlayer = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
      src,
      playbackId,
      onPlay,
      onSeeked,
      onEnded,
      startTime,
      className
    } = _a,
    props = __rest(_a, ["src", "playbackId", "onPlay", "onSeeked", "onEnded", "startTime", "className"]);
  return jsx(PlayerComponent, Object.assign({
    ref: ref,
    src: src,
    streamType: "on-demand",
    playbackId: playbackId,
    onPlay: onPlay,
    onSeeked: onSeeked,
    onEnded: onEnded,
    preload: "auto",
    startTime: startTime,
    className: className
  }, props));
});

export { MuxPlayer as default };
